"use client";

import { X } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const STORAGE_KEY = "condition_selected";

export default function FareAcceptancePopup() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const router = useRouter();

  // 🔑 Open popup on route change IF condition not accepted
  useEffect(() => {
    const value = localStorage.getItem(STORAGE_KEY);

    if (!value) {
      setOpen(true);
      document.body.style.overflow = "hidden";
    } else {
      setOpen(false);
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [pathname]);

  const handleSelect = (value: string) => {
    localStorage.setItem(STORAGE_KEY, value);
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  // ✅ THIS IS REQUIRED
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-md py-4 px-5 w-[90%] max-w-lg relative">
        <h2 className="text-lg mb-4 border-b border-gray-300 text-gray-700">
          Fare Acceptance Form
        </h2>

        {/* ❌ CLOSE BUTTON NOW WORKS */}
        <button
          onClick={() => {
            setOpen(false);
            document.body.style.overflow = "auto";
          }}
          className="absolute top-[10px] right-[10px] cursor-pointer"
        >
          <X />
        </button>

        <p className="text-xs text-gray-700">
          Hello, User. Thanks for registration. Please accept the company fare or
          enter your fare.
        </p>

        <div className="flex items-center gap-3 mt-6">
          <button
            onClick={() => handleSelect("company_fare")}
            className="px-3 py-2 bg-blue-600 text-white rounded text-xs"
          >
            Accept Company Fare
          </button>

          <span className="text-xs text-gray-700">or</span>

          <button
            onClick={() => {
              router.push("/vendor-cab-fare");
              setOpen(false);
            }}
            className="px-3 py-2 bg-green-600 text-white rounded text-xs"
          >
            Enter your Fare
          </button>
        </div>
      </div>
    </div>
  );
}
